import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountContentInfoCard() {
	const contentInfoCard = document.getElementById('content-info-card');

	if (!contentInfoCard) {
		console.warn('[ContentInfoCard] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'ContentInfoCardApp',
	});
	app.component(
		'content-info-card',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "content-info-card" */ 'shared/components/contentLibrary/contentInfoCard.vue'
				),
		),
	);
	app.component(
		'send-campaign-id-cta-button',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/SendCampaignIdCtaButton.vue'),
		),
	);
	app.component(
		'cta-button-with-popup-form',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
		),
	);
	app.component(
		'form-kit-builder-container',
		defineAsyncComponent(
			() =>
				import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(contentInfoCard);
}

mountContentInfoCard().catch((error) => {
	console.error('Error mounting ContentInfoCard:', error);
});
